// filepath: src/Links.js
function Links() {
  return (
    <div className="links">
      <a href="https://strydex.is-a.dev/" target="_blank" rel="noopener noreferrer">[IT-портфолио]</a>
      <a href="https://viperlabs.tech/" target="_blank" rel="noopener noreferrer">[Веб-лаборатория]</a>
      <a href="https://github.com/strydex" target="_blank" rel="noopener noreferrer">[GitHub]</a>
      <a href="https://music.yandex.ru/artist/8920838" target="_blank" rel="noopener noreferrer">[Страничка исполнителя STRYDEX | Yandex.Music]</a>
      <a href="https://t.me/millionstrydex" target="_blank" rel="noopener noreferrer">[TG-канал по Крипте]</a>
      <a href="https://t.me/strydeeboy" target="_blank" rel="noopener noreferrer">[Личный TG-канал]</a>
      <a href="https://tiktok.com/@strydexhot" target="_blank" rel="noopener noreferrer">[TikTok]</a>
    </div>
  );
}

export default Links;